module.exports = "/assets/3c0379a017d96e8e93baaa7a4387600b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MX.png
// module id = 2754
// module chunks = 0